import { createContext } from 'react'

const MessageContext = createContext(null)

export default MessageContext
